import { useState } from 'react'

import { InputType } from 'src/types'
import { useLocales } from 'src/contexts'

import { Filters } from 'src/pages/FuelTrackingHistory/types'
import { DEFAULT_FILTERS } from 'src/pages/FuelTrackingHistory/constants'
import { getFuelTypeOptions } from 'src/pages/FuelTracking/helpers'
import { FuelType } from 'src/pages/FuelTracking/enums'
import { SheetForHistoryOfFuelTrackingProps } from 'src/features/SheetForHistoryOfFuelTracking/types'
import { getFilterFields } from 'src/features/SheetForHistoryOfFuelTracking/helpers'

export const useSheetForHistoryOfFuelTracking = ({
  filters,
  setFilters,
}: SheetForHistoryOfFuelTrackingProps) => {
  const { translations } = useLocales()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [localFilters, setLocalFilters] = useState<Filters>(filters)

  const onSave = (): void => {
    setIsOpen(false)
    setFilters(localFilters)
  }

  const onReset = (): void => {
    setFilters(DEFAULT_FILTERS)
    setIsOpen(false)
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: keyof typeof localFilters,
    type: InputType,
  ): void => {
    setLocalFilters(prev => ({
      ...prev,
      [key]:
        type === 'number'
          ? e.target.value === ''
            ? null
            : Number(e.target.value)
          : e.target.value,
    }))
  }

  const handleChangeFuelType = (value: FuelType): void => {
    setLocalFilters(prevState => ({ ...prevState, fuelType: value }))
  }

  return {
    locale: translations.trackFuel.historyFuel.filters,
    isOpen,
    setIsOpen,
    onSave,
    onReset,
    handleChange,
    localFilters,
    filterFields: getFilterFields(translations.trackFuel.historyFuel.filters),
    fuelTypeOptions: getFuelTypeOptions(translations.trackFuel),
    handleChangeFuelType,
  }
}
